import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default class CatalogFragment extends EmberDataBaseFragment {}